import { Helmet } from "react-helmet";

import type { FC } from "react";

export interface RenderBlockingScriptProps {
  url: string;
  timeOut?: number;
}

/**
 * Render Blocking Script
 *
 * Since we need to add scripts that are render blocking on our site
 * We can use this component to add script and set a timeout to remove if
 * the script does not resolve. this will prevent render blocking
 *
 * the default timeout is 15s
 *
 * @param {url: string; timeOut: number} url, timeOut
 * @returns
 */
export const RenderBlockingScript: FC<RenderBlockingScriptProps> = ({ url, timeOut = 15000 }) => (
  <Helmet>
    <script type="text/javascript">{`(function() {var script = document.createElement('script');script.src = '${url}';script.type = 'text/javascript';document.head.appendChild(script);var timeout = setTimeout(function() {document.head.removeChild(script);}, ${timeOut});script.onload = function() {clearTimeout(timeout);}})();`}</script>
  </Helmet>
);
